// extracted by mini-css-extract-plugin
module.exports = {"popupHeader":"popupHeader-36iY8","paper":"paper-271O_","dialog__header":"dialog__header-3OLXC","header":"header-3S9u-"};